var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"navbtn",attrs:{"id":"navbtn"},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"bar"}),_c('span',{staticClass:"bar"}),_c('span',{staticClass:"bar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }